
export async function getParameters(access_token, key, subkey) {
    if (!access_token.token) return null;
    const res = await fetch("/api/model/parameters/" + key + "/" + subkey + "?_t=" + access_token.token)
    const res_data = await res.json();
    if (res_data.rc == "ok") {
        return res_data.data;
    } else {
        return null;
    };
}

